<script lang="ts">
    import { SERVICE, type BalanceAllEntity } from '../../modules/brokerApi/balances/balance.entity'
    import { Channel } from '../../modules/brokerApi/channels/channel'
    import { ChannelType } from '../../modules/brokerApi/channels/channels.enum'
    import Zinput from './z/zinput.svelte'
    import { writable } from 'svelte/store'
    import Popover from './popover.svelte'
    import Zframe from './z/zframe.svelte'
    import ZContainerCol from './z/z-container-col.svelte'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import ZContainer from './z/z-container.svelte'
    import Zbutton from './z/zbutton.svelte'
    import { faPaperPlane } from '@fortawesome/free-solid-svg-icons'
    import type { CreateRecipientDto, WABAGenericComponentTemplate } from '../../modules/brokerApi/recipients/create-recipient.dto'
    import { MESSAGE_TYPE } from '../../modules/brokerApi/creatives/creative.enum'
    import LoadSpinner from './load-spinner.svelte'
    import { type SendMessageDto } from './send-message.dto'
    import type { GridButton } from './z/zgrid'
    import ZentitySelect from './z/zentity-select.svelte'
    import type { Creative } from '../../modules/brokerApi/creatives/creative'

    let step = 1
    let localMessage: SendMessageDto = null
    let show = false

    let channel: channelInterface = null
    let person: Person = null
    let subject: string = ''
    let message: string = ''
    let to: string = ''
    let showSubject = false
    let allowMessage = true
    let templated = false
    let creativeId: string = null
    let wabaTemplateNameDisabled: boolean = false

    let acts: GridButton[] = []

    export const globalMessage = writable(null)

    window.message = (message: SendMessageDto) => {
        globalMessage.update((_) => message)
    }

    globalMessage.subscribe(async (value: SendMessageDto) => {
        to = ''
        localMessage = null
        person = null
        channel = null
        subject = undefined
        message = ''
        showSubject = false
        acts = []
        step = 0
        if (!value) return
        localMessage = value
        if (localMessage.personId) {
            person = await window.api.events.persons.getOne(localMessage.personId)
        }
        if (channels.length === 0) await loadChannels()
        await loadChannelsList()
        await evaluateDefaultProvider()
        acts.push({
            label: 'Enviar',
            icon: faPaperPlane,
            callback: goSend,
            color: 'primary',
        })
        acts = acts
        step = 1
        console.log('message', value)
    })

    interface channelInterface {
        type: 'zandu' | 'user'
        service: SERVICE
        id: string
        label: string
        balance?: number
        available: boolean
        wabaId: string
        from: string
    }

    let channelsOptions: { value: string; label: string; group: string; disabled: boolean }[] = []
    let channelsList: channelInterface[] = []

    let channels: Channel[] = []
    let balances: BalanceAllEntity = null
    async function loadChannels() {
        try {
            show = true
            channels = await window.api.brokers.channels.getAll({ updateStatus: false })
            balances = await window.api.brokers.balances.getAllBalance()
        } catch (error) {
        } finally {
            show = false
        }
    }

    async function loadChannelsList() {
        channelsOptions = []
        channelsList = []
        // CARREGA PROVEDORES ZANDU
        // for (const item of balances.balance) {
        //     if (item.service === 'push') continue
        //     if (item.service === 'evo') continue
        //     if (item.service === 'sms') continue
        //     let label = evaluateChannelName(item.service)
        //     let available = true
        //     if (item.service === 'waba' && !localMessage.template) available = false
        //     channelsList.push({ type: 'zandu', id: item.service, service: item.service as any, label: label, balance: item.balance, available, wabaId: null })
        //     channelsOptions.push({ value: item.service, label: label + ' | saldo: ' + item.balance, group: 'Provedores Zandu', disabled: !available })
        // }
        // CARREGA PROVEDORES DO USUÁRIO
        for (const item of channels) {
            if (item.type === ChannelType.voip_user) continue
            if (item.type === ChannelType.call_user) continue
            if (item.type === ChannelType.sms_smsempresa) continue
            //if (item.type === ChannelType.waba_user) continue
            const available = item.status >= 100 ? true : false
            const mappedService = mapChannelTypeToService(item)
            channelsList.push({
                type: 'user',
                id: item.channelId,
                service: mappedService.service,
                label: item.label,
                available,
                wabaId: item.credentials?.wabaID,
                from: mappedService.from,
            })

            channelsOptions.push({ value: item.channelId, label: item.label, group: 'Meus Provedores', disabled: !available })
        }
    }

    function evaluateChannelName(service: string) {
        if (service === 'waba') return 'Zandu WhatsApp Business'
        if (service === 'evo') return 'Zandu WhatsApp Web'
        if (service === 'email') return 'Zandu E-Mail'
        if (service === 'sms') return 'Zandu SMS'
        if (service === 'push') return 'Zandu Notificação'
        return service
    }

    function goClose() {
        globalMessage.set(null)
    }

    async function evaluateDefaultProvider() {
        if (localMessage.channelId) {
            await onProviderChange()
        }
    }

    async function onProviderChange() {
        channel = channelsList.find((item) => item.id === localMessage?.channelId)
        console.log('channel', channel)
        if (!channel) return
        message = localMessage.message
        allowMessage = true
        templated = false

        await loadTemplates(channel.wabaId)
        evaluateTo()
        showSubject = channel.service === SERVICE.EMAIL || channel.service === SERVICE.PUSH
        if (channel.service === SERVICE.EMAIL) {
            subject = localMessage.subject
        }
        if (channel.service === SERVICE.EVO) {
        }
        if (channel.service === SERVICE.SMS) {
            message = localMessage.smsMessage || localMessage.message
        }
        if (channel.service === SERVICE.WABA) {
            detectTemplate()
            generateTemplateMessage()
            templated = true
            allowMessage = false
        }
    }

    let wabaTemplateSelected: Creative = null
    function detectTemplate() {
        wabaTemplateNameDisabled = false
        if (localMessage.template && channel.type === 'user' && channel.service === 'waba') {
            const found = templates.find((el) => el.wabaName.startsWith(localMessage?.template?.name))
            if (!found) return
            wabaTemplateSelected = found
            creativeId = found.creativeId
            wabaTemplateNameDisabled = true
        }
    }

    let inputVariables: WABAGenericComponentTemplate[] = []
    function generateTemplateMessage() {
        inputVariables = []
        message = ''
        wabaTemplateSelected = null
        let _message: string = ''
        if (channel.type === 'user' && channel.service === 'waba') {
            const selected = templates.find((el) => el.creativeId == creativeId)
            if (!selected) return
            wabaTemplateSelected = selected
            const body = selected.wabaComponents?.find((el) => el.type === 'BODY')
            if (!body) return
            _message = body.text
            // caso não tenha informado as vars, então solicitar digitação.
            //generateInputVariables(selected, localMessage.template?.variables)
        }

        message = _message
    }

    // function generateInputVariables(template: Creative, variables: string[]) {
    //     inputVariables = []
    //     let varPos = 0
    //     for (const c of template.wabaComponents) {
    //         if (c.type === 'BODY') {
    //             const item: WABAGenericComponentTemplate = {
    //                 type: 'BODY',
    //                 parameters: [],
    //             }
    //             if (c.example?.body_text?.length > 0) {
    //                 let paramsCount = c.example.body_text[0].length
    //                 for (let index = 0; index < paramsCount; index++) {
    //                     const param = { type: 'text', text: '' } as any
    //                     if (variables?.length > varPos) {
    //                         param.text = variables[varPos]
    //                         varPos++
    //                     }
    //                     item.parameters.push(param)
    //                 }
    //             }
    //             inputVariables.push(item)
    //         }
    //         if (c.type === 'BUTTONS') {
    //             let buttonIndex = -1
    //             for (const button of c.buttons) {
    //                 buttonIndex++
    //                 const param = { type: 'text', text: '' } as any
    //                 if (variables?.length > varPos) {
    //                     param.text = variables[varPos]
    //                     varPos++
    //                 }
    //                 const item: WABAGenericComponentTemplate = {
    //                     type: 'BUTTON',
    //                     sub_type: button.type,
    //                     index: buttonIndex,
    //                     parameters: [param], // variável
    //                 }
    //                 inputVariables.push(item)
    //             }
    //         }
    //     }
    //     inputVariables = inputVariables
    //     console.log('creative', template)
    //     console.log('inputVariables', inputVariables)
    // }

    function evaluateTo() {
        to = ''
        if (!channel) return ''
        if (!person) return ''
        if (channel.service === SERVICE.EMAIL) return (to = person?.email)
        if (channel.service === SERVICE.SMS) return (to = person?.phone)
        if (channel.service === SERVICE.WABA) return (to = person?.phone)
        if (channel.service === SERVICE.EVO) return (to = person?.phone)
        if (channel.service === SERVICE.WA) return (to = person?.phone)
        if (channel.service === SERVICE.CALL) return (to = person?.phone)
        return (to = person?.name || '')
    }

    async function goSend() {
        // todo: enviar conteúdo
        // exibir disclaimer nas mensagens de monitoramento
        // se e-mail exibir: "De: xyz@clinica.com.br"
        // considerar exibir "De: " para todos os provedores. ficaria mais claro para quem envia, inclusive exibindo o número do Zandu WABA e Zandu WhatsApp Web.
        if (!person) {
            window.alert('Escolha um destinatário antes de continuar.')
            return
        }
        if (!channel) {
            window.alert('Escolha um provedor antes de continuar.')
            return
        }
        if (!message) {
            window.alert('Escreva uma mensagem antes de continuar.')
            return
        }
        if (channel.service === SERVICE.WABA) {
            if (!localMessage.template && !wabaTemplateSelected) {
                window.alert('Nenhum template selecionado.')
                return
            }
            if (wabaTemplateSelected && inputVariables?.length > 0) {
                if (inputVariables.some((el) => el.parameters.some((p) => p.text.trim() === ''))) {
                    window.alert('Informe os valores dos parâmetros antes de enviar o template.')
                    return
                }
            }
        }
        try {
            if (show) return
            show = true
            let to: string = person.personId
            let caption: string = undefined
            let push = undefined
            let replyTo = undefined
            let replyToName = undefined
            let evaluatedMessage = message
            let wabaTemplate = undefined
            if (channel.service === SERVICE.EMAIL) {
                caption = subject
                replyTo = window.store.company.email
                replyToName = window.store.company.companyName
                evaluatedMessage = message.replace(/\n/g, '<br />')
            }
            if (channel.service === SERVICE.PUSH) {
                push = {
                    icon: null,
                    image: null,
                    title: subject,
                    body: evaluatedMessage,
                }
            }
            if (channel.service === SERVICE.EVO || channel.service === SERVICE.SMS || channel.service === SERVICE.WA) {
            }
            if (channel.service === SERVICE.WABA) {
                if (localMessage.template) {
                    evaluatedMessage = ''
                } else {
                    evaluatedMessage = ''
                }
            }

            const data: CreateRecipientDto = {
                recipients: [
                    {
                        fromName: window.store.company.companyName,
                        message: evaluatedMessage,
                        messageType: MESSAGE_TYPE.TEXT,
                        service: channel.service,
                        to,
                        caption,
                        priority: true,
                        push,
                        replyTo,
                        replyToName,
                        replace: localMessage?.template?.replace || undefined,
                        creativeId,
                    },
                ],
                channelId: channel.id,
            }
            const result = await window.api.brokers.recipient.send(data)
            console.log('sent', result)
            acts = []
            step = 2
        } catch (error) {
            window.error(error)
            window.error(error)
        } finally {
            show = false
        }
    }

    function mapChannelTypeToService(channel: Channel): { service: SERVICE; from: any } {
        if (channel.type === ChannelType.wa_user) return { service: SERVICE.WA, from: window.store.company.companyName }
        if (channel.type === ChannelType.email_sendgrid) return { service: SERVICE.EMAIL, from: window.store.company.email }
        if (channel.type === ChannelType.sms_smsempresa) return { service: SERVICE.SMS, from: window.store.company.companyName }
        if (channel.type === ChannelType.wa_evo2_user || channel.type === ChannelType.wa_evo2_zandu)
            return { service: SERVICE.EVO, from: window.store.company.companyName }
        // uazapi compartilha o SERVICE.EVO; o provedor real é resolvido pelo channelId no backend
        if (channel.type === ChannelType.wa_uazapi_user || channel.type === ChannelType.wa_uazapi_zandu)
            return { service: SERVICE.EVO, from: window.store.company.companyName }
        if (channel.type === ChannelType.waba_user) return { service: SERVICE.WABA, from: window.store.company.companyName }
        if (channel.type === ChannelType.voip_user || channel.type === ChannelType.call_user)
            return { service: SERVICE.CALL, from: window.store.company.companyName }
        if (channel.type === ChannelType.email_gmail || channel.type === ChannelType.email_sendgrid) {
            return { service: SERVICE.EMAIL, from: channel.credentials?.googleEmail || window.store.company.email }
        }
        throw new Error("Can't map channel type to service")
    }

    let wabaOptions: { value: string; label: string }[] = []
    let templates: Creative[] = []
    async function loadTemplates(wabaId: string) {
        wabaOptions = []
        templates = []
        if (!wabaId) return
        templates = await window.api.brokers.creatives.getAll({ wabaId })
        for (const t of templates) {
            wabaOptions.push({
                label: t.label,
                value: t.creativeId,
            })
        }
        wabaOptions = wabaOptions
    }
</script>

{#if localMessage}
    <Popover on:close={goClose} width="970px" title="Enviar Mensagem">
        <div class="root_send-message">
            <Zframe title="Mensagem" class="m-3" {acts}>
                {#if step === 1}
                    <ZContainer>
                        <Zinput
                            label="Provedor"
                            size={6}
                            type="select"
                            options={channelsOptions}
                            bind:value={localMessage.channelId}
                            on:change={onProviderChange}
                        ></Zinput>

                        <Zinput
                            help="Para alguns provedores você pode alterar esta informação acessando 'Conta' e 'Minhas Empresas'"
                            disabled={true}
                            label="De"
                            size={6}
                            type="text"
                            value={channel?.from}
                        ></Zinput>

                        <ZContainerCol size={6}>
                            <ZentitySelect fonte="pessoa" label="Destinatário" bind:value={person} on:change={evaluateTo}></ZentitySelect>
                        </ZContainerCol>

                        <Zinput disabled={true} label="Para" size={6} type="text" bind:value={to}></Zinput>

                        {#if showSubject}
                            <Zinput label="Assunto" size={12} type="text" bind:value={subject}></Zinput>
                        {/if}
                        {#if wabaOptions.length > 0}
                            <Zinput
                                label="Template"
                                size={6}
                                type="select"
                                options={wabaOptions}
                                bind:value={creativeId}
                                disabled={wabaTemplateNameDisabled}
                                on:change={generateTemplateMessage}
                            ></Zinput>
                        {/if}
                        <Zinput rows={12} disabled={!allowMessage} label="Mensagem" size={12} type="textarea" class="send-message_message" bind:value={message}
                        ></Zinput>
                        {#if inputVariables?.length > 0}
                            {#each inputVariables as v}
                                {#each v.parameters as param, index}
                                    <Zinput rows={12} label="Variável {`${v.type} {{${index + 1}}}`}" size={12} type="text" bind:value={param.text}></Zinput>
                                {/each}
                            {/each}
                        {/if}

                        {#if templated}
                            <ZContainerCol size={12}>
                                <div class="alert alert-light text-center mb-0">Mensagens através do WhatsApp Business não podem ser editadas.</div>
                            </ZContainerCol>
                        {/if}
                    </ZContainer>
                {/if}
                {#if step === 2}
                    <div class="d-flex flex-column align-items-center">
                        <div class="alert alert-success">Mensagem adicionada na fila para envio.</div>
                        <Zbutton label="Fechar" on:click={goClose}></Zbutton>
                    </div>
                {/if}
            </Zframe>
        </div>
    </Popover>
    <LoadSpinner delay={0} {show}></LoadSpinner>
{/if}

<style>
    .root_send-message :global(.send-message_message) {
        resize: none;
    }
    .alert {
        opacity: 0.6;
    }
</style>
